export default { sha: 'e73ee6dd1003f21ee15ded38351a249f002d1357', buildNumber: 'undefined' }
